const IconList = () => {


  return (
    <div className="flex">
      <div className="block">
        <div className="relative bg-white h-9 w-9 rounded-full mb-2 border border-1 border-black" >
          <a
            href="https://www.facebook.com/OffsetGo/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="absolute left-1 top-1"
              src="/images/icons/fb.png"
              alt="Facebook"
            />
          </a>
        </div>
        <div className="flex">
          <div className="relative bg-white h-9 w-9 rounded-full mb-2 mr-2  border border-1 border-black">
            <a
              href="https://www.instagram.com/offsetgo.earth/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="absolute left-1.5 top-1.5"
                src="/images/icons/instagram.png"
                alt="Instagram"
              />
            </a>
          </div>
          <div className="relative bg-white h-9 w-9 rounded-full mb-2  border border-1 border-black">
            <a
              href="https://twitter.com/offset_go"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="absolute left-2 top-2"
                src="/images/icons/twitter.png"
                alt="Twitter"
              />
            </a>
          </div>
        </div>
        <div className="flex">
          <div className="relative bg-white h-9 w-9 rounded-full mb-2 mr-2  border border-1 border-black">
            <a
              href="https://www.youtube.com/channel/UC5rh6a3k6bGTBbyLidQOWDg"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="absolute  p-1.5"
                src="/images/icons/youtube.png"
                alt="YouTube"
              />
            </a>
          </div>
          <div className="relative bg-white h-9 w-9 rounded-full mb-2 mr-2  border border-1 border-black">
            <a
              href="https://in.linkedin.com/company/offset-go"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="absolute p-1.5"
                src="/images/icons/linkedin.png"
                alt="LinkedIn"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IconList;
